import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Component, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalRepository } from '@shared/helper/local-repository';
import { SigninService } from '@shared/service/http_services/signin.service';
import { UserStateService } from '@app/state/user-state.service';
import { Router } from '@angular/router';
import { htmlUrls } from '@shared/utils/router-paths';

@Component({
  selector: 'app-exit-bottom-sheet',
  templateUrl: './exit-bottom-sheet.component.html',
  styleUrls: ['./exit-bottom-sheet.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule
  ]
})
export class ExitBottomSheetComponent {
  private _bottomSheet = inject(MatBottomSheet);
  private _dialog = inject(MatDialog);
  private signinService = inject(SigninService);
  private _localRepository = inject(LocalRepository);
  private userStateService = inject(UserStateService);
  private router = inject(Router);
  urlApp!: string;

  logout() {
    if (this._localRepository.IsInBrowser) {
      this.userStateService.resetUserState();
      this.router.navigate([htmlUrls.home]);
      this.dismiss();
      this.signinService.signOut();
    }
  }

  dismiss() {
    if (!this._localRepository.IsInBrowser) return;

    if (this._localRepository.IsInMobile)
      this._bottomSheet.dismiss();
    else
      this._dialog.closeAll();
  }

}
